export enum ConsentStatus {
  CONFIRMED = 'CONFIRMED',
  WITHDRAWN = 'WITHDRAWN',
  LEGITIMATE_INTEREST = 'LEGITIMATE_INTEREST'
}
